import * as React from "react";

import {
  ProgressBar as FluentProgressBar,
  ProgressBarProps as FluentProgressBarProps,
} from "@fluentui/react-components";

export interface ProgressBarProps extends FluentProgressBarProps {
  loading?: boolean;
}

/**
 * ProgressBar component
 * Wraps Fluent UI ProgressBar with custom props
 * Colors are automatically themed via FluentProvider
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ className, ...props }) => {
  return (
    <div className={className}>
      <FluentProgressBar {...props} />
    </div>
  );
};

export default ProgressBar;
